import React, { createContext, useMemo, useState } from 'react';
export const DEFAULT_NEDBETALINGSTID = 30;
export const DEFAULT_MARKEDSRENTE = 6.0;
export const DEAFULT_LAANEBELOP = 2000000;
export const AppContext = createContext({
    laaneparam: {
        aarsinntekt: undefined,
        antallBarn: '',
        antallBiler: '',
        antallLaantakere: '',
        gjeld: undefined,
        rente: DEFAULT_MARKEDSRENTE,
        nedbetalingstid: DEFAULT_NEDBETALINGSTID,
        laanebeloep: DEAFULT_LAANEBELOP,
    },
    setLaaneparam: (laaneparam) => {
        return laaneparam;
    },
});
const KalkulatorState = ({ children }) => {
    const [laaneparam, setLaaneparam] = useState({
        aarsinntekt: undefined,
        antallBarn: '',
        antallBiler: '',
        antallLaantakere: '',
        gjeld: undefined,
        rente: DEFAULT_MARKEDSRENTE,
        nedbetalingstid: DEFAULT_NEDBETALINGSTID,
        laanebeloep: DEAFULT_LAANEBELOP,
    });
    const state = useMemo(() => ({
        laaneparam,
        setLaaneparam,
    }), [laaneparam, setLaaneparam]);
    return React.createElement(AppContext.Provider, { value: state }, children);
};
export default KalkulatorState;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2Fsa3VsYXRvclN0YXRlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbnRhaW5lcnMva2Fsa3VsYXRvclN0YXRlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQUssRUFBRSxFQUFFLGFBQWEsRUFBaUIsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLE9BQU8sQ0FBQztBQUUvRSxNQUFNLENBQUMsTUFBTSx1QkFBdUIsR0FBRyxFQUFFLENBQUM7QUFDMUMsTUFBTSxDQUFDLE1BQU0sb0JBQW9CLEdBQUcsR0FBRyxDQUFDO0FBQ3hDLE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHLE9BQU8sQ0FBQztBQWtCMUMsTUFBTSxDQUFDLE1BQU0sVUFBVSxHQUFHLGFBQWEsQ0FBaUI7SUFDcEQsVUFBVSxFQUFFO1FBQ1IsV0FBVyxFQUFFLFNBQVM7UUFDdEIsVUFBVSxFQUFFLEVBQUU7UUFDZCxXQUFXLEVBQUUsRUFBRTtRQUNmLGdCQUFnQixFQUFFLEVBQUU7UUFDcEIsS0FBSyxFQUFFLFNBQVM7UUFDaEIsS0FBSyxFQUFFLG9CQUFvQjtRQUMzQixlQUFlLEVBQUUsdUJBQXVCO1FBQ3hDLFdBQVcsRUFBRSxrQkFBa0I7S0FDbEM7SUFDRCxhQUFhLEVBQUUsQ0FBQyxVQUFzQixFQUFFLEVBQUU7UUFDdEMsT0FBTyxVQUFVLENBQUM7SUFDdEIsQ0FBQztDQUNKLENBQUMsQ0FBQztBQU1ILE1BQU0sZUFBZSxHQUFjLENBQUMsRUFBRSxRQUFRLEVBQUUsRUFBRSxFQUFFO0lBQ2hELE1BQU0sQ0FBQyxVQUFVLEVBQUUsYUFBYSxDQUFDLEdBQUcsUUFBUSxDQUFhO1FBQ3JELFdBQVcsRUFBRSxTQUFTO1FBQ3RCLFVBQVUsRUFBRSxFQUFFO1FBQ2QsV0FBVyxFQUFFLEVBQUU7UUFDZixnQkFBZ0IsRUFBRSxFQUFFO1FBQ3BCLEtBQUssRUFBRSxTQUFTO1FBQ2hCLEtBQUssRUFBRSxvQkFBb0I7UUFDM0IsZUFBZSxFQUFFLHVCQUF1QjtRQUN4QyxXQUFXLEVBQUUsa0JBQWtCO0tBQ2xDLENBQUMsQ0FBQztJQUVILE1BQU0sS0FBSyxHQUFHLE9BQU8sQ0FDakIsR0FBRyxFQUFFLENBQUMsQ0FBQztRQUNILFVBQVU7UUFDVixhQUFhO0tBQ2hCLENBQUMsRUFDRixDQUFDLFVBQVUsRUFBRSxhQUFhLENBQUMsQ0FDOUIsQ0FBQztJQUVGLE9BQU8sb0JBQUMsVUFBVSxDQUFDLFFBQVEsSUFBQyxLQUFLLEVBQUUsS0FBSyxJQUFHLFFBQVEsQ0FBdUIsQ0FBQztBQUMvRSxDQUFDLENBQUM7QUFFRixlQUFlLGVBQWUsQ0FBQyJ9